import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmOwnerForm from '../../../components/forms/FirearmOwnerForm';
import { useFirearmOwnerById, useUpdateFirearmOwner } from '../../../hooks/useFirearmOwnerApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmOwnerDTO } from '../../../services/apiClient';

const FirearmOwnerEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmOwnerById(id!);
  const updateFirearmOwner = useUpdateFirearmOwner();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Owners', href: '/admin/firearmowners' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Firearm Owner data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/firearmowners');
    } catch (error) {
      console.error('Error updating Firearm Owner:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmowners"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmOwner.Edit'
    >
        {entityData ? (
          <FirearmOwnerForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmowners')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmOwnerEdit;